import React, {useEffect} from "react";
import "./Fact.sass";

export default function Fact({title, onClose, children}) {

    useEffect(() => {
        if (onClose) {
            setTimeout(onClose, 30000)
        }
    }, [])

    return (
        <div className="Fact-wrapper" onClick={onClose || (() => {})}>
            <div className="Fact-content">
                    <div><b>{title}</b></div>
                    <div>{children}</div>
            </div>
        </div>
    )
}